/**
 * The global catalogue of liqui-loc: the words BOTH apps use, LIQUIDO and Polly, in one central place.
 * Each app passes it to createLoc() in its main.js; texts that belong to one page only stay in that component's
 * own `i18n: { messages }` option, and Polly keeps its own texts in src/polly/services/polly-messages.js.
 *
 * A component's own message for the same key wins over this one (see the lookup order in liqui-loc.js).
 *
 * Capital translations also have a capital key, eg.  Cancel: "Cancel" both with capital 'C'.
 */
export default {
	en: {
		HelloWorld: "Hello world!",
		pollChangedMeanwhile: "Sorry, your admin has just changed this poll. I am loading it again.",
		Ok: "Ok",
		Yes: "Yes",
		No: "No",
		Cancel: "Cancel",
		Password: "Password",
		impressumLink: "Legal Notice",
		agbLink: "Terms",
		datenschutzLink: "Privacy",
		Save: "Save",
		Edit: "Edit",
		Next: "Next",
		Share: "Share",
		TryAgain: "Try again",
	},
	de: {
		HelloWorld: "Hallo Welt!",
		Ok: "Ok",
		Yes: "Ja",
		No: "Nein",
		Menue: "Menü",
		Team: "Team",
		
		Save: "Speichern",
		Edit: "Bearbeiten",
		Send: "Senden",
		Delete: "Löschen",
		Cancel: "Abbrechen",
		Back: "Zurück",
		Search: "Suche",
		Warning: "Warnung",
		Attention: "Achtung",
		Error: "Fehler",
		Login: "Login",
		Password: "Passwort",
		Loading: "Lade ...",
		Next: "Weiter",
		Share: "Teilen",
		TryAgain: "Nochmal versuchen",

		// Singular and plural form
		Idea: "Idee",
		Ideas: "Ideen",
		Proposal: "Vorschlag",  // 'Wahlvorschlag' ist zu lang. 'Option' zu allgemein. 'Kandidat' wäre für Personenwahlen. 
		Proposals: "Vorschläge",
		// Entscheidung zur deutschen Übersetzung von Poll == "Abstimmung" !!!
		// Nein nicht "Wahl". Wir stimmen ab in LIQUIDO. Der Begriff "Wahl" passt eher zu einer Wahl von Kandidaten, also Personen.
		vote: "abstimmen",   // Verb
		Poll: "Abstimmung",
		Polls: "Abstimmungen",
		Law: "Regel",   // Gesetz? ... vielleicht irgendwann mal wenn die LIQUIDO Liquid Democracy Revolution erfolgreich war :-)
		Laws: "Regeln",

	
		newPoll: "Neue Abstimmung",
		allPolls: "Alle Abstimmungen",
		YourPolls: "Abstimmungen",
		pollTitle: "Titel der Abstimmung",
		pollInElaboration: "Neue Abstimmung",   // Im großen LIQUIDO: "Abstimmung zur Debatte"m denn das elaborierte Fremdwort "Debatte" macht den Eindruck den wir wollen.
		pollsInElaboration: "Neue Abstimmungen",
		pollInVoting: "Laufende Abstimmung",
		pollsInVoting: "Laufende Abstimmungen",
		finishedPoll: "Abgeschl. Abstimmung",   // Muss abkürzen, weil Titel der poll-show page sonst zu lang auf schmalen Phones
		finishedPolls: "Abgeschl. Abstimmungen",


		New: "Neu",									// Neue Abstimmung
		Elaboration: "Diskussion",	// Abstimmung die gerade debatiert wird. (Nur für großes LIQUIDO)
		InVoting: "Wahl läuft", 		// Abstimmung im Status "die Wahl läuft gerade" 
		Finished: "Abgeschlossen",  // "Beendet" ?
		User: "Profil",
		gotoPolls: "Abstimmungen",  // Link to /polls page  short!
		impressumLink: "Impressum",
		agbLink: "AGB",
		datenschutzLink: "Datenschutz",
		inviteNewMembers: "Teammitglieder einladen",
		SwitchTeam: "Team wechseln",   // only shown to users who are in more than one team
		TeamHome: "Team",
		JoinTeam: "Team beitreten",   // page title of join-team-v2.vue, also used as its header title

		// Global error messages 
		unexpectedError: "Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut.",
		// LIQUIDO: a like or save failed because somebody changed the open poll (src/liquido/services/poll-changed-meanwhile.js)
		pollChangedMeanwhile: "Bitte entschuldige, euer Admin hat diese Abstimmung gerade noch mal geändert. Ich lade sie neu.",
		networkError: "Ein Netzwerkfehler ist aufgetreten. Bitte versuche es erneut.",
		

		// Need these translations here, because of an issue when upgrading vue-i18n
		// Or maybe it's even a good idea to have all translations in one place => NO its not!! :-)  => In LIQUIDO we want to have visual in place translation service per page

		// Polls page
		"noPollYet": "Es gibt noch keine Abstimmungen in eurem Team.",
		"noPollsMatchSearch": "Keine Abstimmungen passen zu deiner Suche.",
		"onlyAdminCanCreateNewPolls": "Nur du als Admin kannst neue Abstimmungen erstellen.",
		"createNewPoll": "Neu Abstimmung erstellen"
	},
}
